import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button2Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M8 9H3V0H8V9ZM12 13H21V18H12V13ZM11 15.5C11 18.5376 8.53757 21 5.5 21C2.46243 21 0 18.5376 0 15.5C0 12.4624 2.46243 10 5.5 10C8.53757 10 11 12.4624 11 15.5ZM7.33333 15.5C7.33333 16.5125 6.51252 17.3333 5.5 17.3333C4.48748 17.3333 3.66667 16.5125 3.66667 15.5C3.66667 14.4875 4.48748 13.6667 5.5 13.6667C6.51252 13.6667 7.33333 14.4875 7.33333 15.5Z" />
  </SvgIcon>
);

export default PO28Button2Icon;
